module.exports = __webpack_public_path__ + "contactCover.752d34eafda9c24acb2a.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/contactCover.jpg
// module id = ../../../../../src/assets/coverPicks/contactCover.jpg
// module chunks = 0